import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SuitClub.svg",
  "use": "SuitClub.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"SuitClub.svg\"><path d=\"M22.01,26.025a11.0863,11.0863,0,0,1,1.6214.12,11,11,0,1,1,16.7575,0,11.0008,11.0008,0,1,1-6.6465,18.1275,19.31,19.31,0,0,0,4.9237,8.41l1.9188,1.9194a.8332.8332,0,0,1-.5891,1.4226H24.0248a.8334.8334,0,0,1-.5894-1.4226l1.9188-1.9194a19.3109,19.3109,0,0,0,4.924-8.41A10.998,10.998,0,1,1,22.01,26.025Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol